import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions";
import axios from "../../axios";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import { IoCalendarClear, IoCalendarClearOutline } from "react-icons/io5";
import { BsCalendarPlus } from "react-icons/bs";
import ReactDatePicker, { setDefaultLocale } from "react-datepicker";
import { withRouter } from "react-router";
import parse from "react-html-parser";
import { sortBy } from "lodash";
import _debounce from "lodash/debounce";

function MonthlyGuidesTable({
  open,
  onClose,
  currentMonth,
  getTableForAnalytics,
  ...props
}) {
  const [filteredGuides, setfilteredGuides] = useState([]);
  const [minDate, setMinDate] = useState(moment().startOf("month"));
  const [maxDate, setMaxDate] = useState(moment().endOf("month"));

  const [searchVal, setSearchVal] = useState("");
  const [dataLoading, setdataLoading] = useState(false);
  const [sortField, setSortField] = useState(""); // Stores the current field to sort by
  const [sortOrder, setSortOrder] = useState("asc"); // Stores the current sorting order
  const [descModal, setDescModal] = useState(null);

  // Sort function
  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);

    // Sort the data based on the field and order
    resultsToShow.sort((a, b) => {
      if (field === "name") {
        return newSortOrder === "asc"
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } else {
        const dateA = moment(a[field]);
        const dateB = moment(b[field]);
        return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      }
    });
  };

  // Function to render sorting arrows
  const renderSortingArrows = (field) => {
    if (sortField === field) {
      return (
        <span className="cursor-pointer">
          {sortOrder === "asc" ? "↑" : "↓"}
        </span>
      );
    }

    return <span className="cursor-pointer">↑</span>;
  };

  useEffect(() => {
    setdataLoading(true);
    handleApplyDateFilter(minDate, maxDate, searchVal);
  }, []);

  const handleSearchChange = (v) => {
    debounceFn(minDate, maxDate, v);
  };
  const handleSearchDeb = (mn, mx, v) => {
    handleApplyDateFilter(mn, mx, v);
  };
  const debounceFn = useCallback(_debounce(handleSearchDeb, 1000), []);

  const resultsToShow = filteredGuides;

  const handleApplyDateFilter = (mnDate, mxDate, search) => {
    setMaxDate(mxDate);
    setMinDate(mnDate);
    setSearchVal(search);

    axios
      .post(url.getDiversityCalendarGuides, {
        search,
        filters: { eventDatesDC: [mnDate, mxDate] },
      })
      .then((data) => {
        setdataLoading(false);

        setfilteredGuides(
          sortBy(data.data, [(x) => moment(x.startDate).format("MM-DD")])
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const renderView = (item) => {
    let link = "";

    if (
      item.attachments &&
      Array.isArray(item.attachments) &&
      item.attachments[0]
    ) {
      link = item.attachments[0].url;
    } else if (item.attachment) {
      link = item.attachment;
    } else if (item.image) {
      link = item.image;
    }

    if (link) {
      return (
        <a className="link-text" href={link} target="_blank">
          (view)
        </a>
      );
    } else {
      return (
        <span>
          <span
            onClick={() => {
              setDescModal(item._id);
            }}
            id={`view_guide_${item._id}`}
            className="link-text"
          >
            (view)
          </span>
          <Modal isOpen={descModal == item._id}>
            <ModalHeader toggle={() => setDescModal(null)}>
              Description
            </ModalHeader>
            <ModalBody>{parse(item.description)}</ModalBody>
          </Modal>
        </span>
      );
    }
  };

  return (
    <div className="monthlyGuidesAnalyticsTable">
      <div className="">
        {dataLoading ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "white",
            }}
          >
            <h5 className="text-center">Loading...</h5>
          </div>
        ) : (
          <div>
            <Table bordered className="mb-0">
              <thead>
                <tr>
                  <th
                    style={{ width: "50%" }}
                    onClick={() => handleSort("name")}
                  >
                    Calendar of Observances {renderSortingArrows("name")}
                  </th>
                  <th
                    style={{ width: "25%" }}
                    onClick={() => handleSort("startDate")}
                  >
                    Start Date {renderSortingArrows("startDate")}
                  </th>
                  <th
                    style={{ width: "25%" }}
                    onClick={() => handleSort("endDate")}
                  >
                    End Date {renderSortingArrows("endDate")}
                  </th>
                </tr>
              </thead>
            </Table>

            <div
              className="no-scr-mob"
              style={{
                maxHeight: "276px",
                overflowY: "auto",
                display: "block",
              }}
            >
              <Table>
                <tbody>
                  {resultsToShow && resultsToShow.length ? (
                    resultsToShow.map((item) => {
                      return (
                        <tr>
                          <td style={{ width: "50%" }}>
                            <span className="dc-name-column">{item.name}</span>{" "}
                            {renderView(item)}
                          </td>
                          <td style={{ width: "25%" }}>
                            {moment(item.startDate).format("MMMM D")}
                          </td>
                          <td style={{ width: "25%" }}>
                            {moment(item.endDate).format("MMMM D")}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <div className="text-center">No Guides to show...</div>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default withRouter(MonthlyGuidesTable);
